export const ShareInput = ({ currentUser, postType, setPostType, desc, setDesc }) => {
    const profilePicUrl = currentUser.profilePic
        ? (currentUser.profilePic.startsWith("http") ? currentUser.profilePic : "/upload/" + currentUser.profilePic)
        : "/public/noAvatar.png";

    return (
        <>
            <div className="userInfo">
                <img src={profilePicUrl} alt="Avatar" />
                <div className="name-wrapper">
                    <span>
                        {currentUser.name}
                    </span>

                    <div className="postTypeContainer">
                        <select value={postType} onChange={(e) => setPostType(e.target.value)}>
                            <option value="Question">
                                Question
                            </option>

                            <option value="Proof attempt">
                                Proof attempt
                            </option>

                            <option value="Counterexample">
                                Counterexample
                            </option>

                            <option value="Research idea">
                                Research idea
                            </option>

                            <option value="Discussion">
                                Discussion
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <textarea 
                placeholder="What's on your mind?" 
                onChange={(e) => setDesc(e.target.value)}
                value={desc}
                rows={4}
                autoFocus
            />
        </>
    );
};